<script setup lang="ts">
  import AppNavigationItem from './AppNavigationItem.vue';
  import { ResolvedAppNavigationConfigItem } from './config';

  interface AppNavigationProps {
    items?: ResolvedAppNavigationConfigItem[];
  }

  const props = withDefaults(defineProps<AppNavigationProps>(), {
    items: () => [],
  });

  const emit = defineEmits<{
    (e: 'navigate'): void;
  }>();
</script>

<template>
  <nav role="navigation" :class="['pb-4', $style.sidenav]">
    <ul :class="['pa-0', $style['nav-list']]">
      <AppNavigationItem
        v-for="item in props.items"
        :item="item"
        :key="item.id"
        force-reload
        @navigate="emit('navigate')"
      />
    </ul>
  </nav>
</template>

<style lang="scss" module>
  .sidenav {
    opacity: 0;
    overflow: auto;
    transition: opacity 0.165s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition-delay: 0.2s;

    :global(.is-sidebar-open) & {
      opacity: 1;
    }

    @include breakpoint(xl) {
      opacity: 1;
    }

    .nav-list {
      list-style: none;
    }
  }
</style>
